import React from 'react';

// Shared card shell for Response Detail sections.
export function Panel({ title, icon: Icon, action, children, testId, className = '' }) {
  return (
    <section className={`bg-white border border-[#E2E8F0] rounded-2xl p-5 ${className}`} data-testid={testId}>
      {(title || action) && (
        <div className="flex items-center justify-between gap-3 mb-4">
          <h2 className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] min-w-0">
            {Icon && <Icon className="w-3.5 h-3.5 shrink-0 text-[#1A3E6F]" />}
            {title}
          </h2>
          {action && <div className="shrink-0 whitespace-nowrap">{action}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

export const FieldRow = ({ label, children, testId }) => (
  <div className="flex flex-col sm:flex-row sm:items-baseline gap-0.5 sm:gap-3 py-2 border-b border-[#F1F5F9] last:border-0" data-testid={testId}>
    <span className="text-xs font-semibold text-[#64748B] sm:w-40 shrink-0">{label}</span>
    <span className="text-sm text-[#0F172A] break-words min-w-0">{children}</span>
  </div>
);
